import {Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import {Cards} from '../cards-mockup';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnChanges, OnInit {

  @Input() level: number;
  @Input() counter: number;
  @Input() isCovered: boolean;
  @Output() cardsChange = new EventEmitter<number[]>();

  numberOfTotalCards = 0;
  cards: number[] = [];
  cardIsVisible: boolean[] = [];
  changeButtonIsVisible: boolean[] = [];
  isDisabled = false;
  wasSorted = false;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.isCovered) {
      if (this.cardIsVisible !== []) {
        const numberOfTotalCards = this.cards.length;
        for (let i = 0; i < numberOfTotalCards; i++) {
          this.cardIsVisible[i] = false;
          this.changeButtonIsVisible[i] = false;
        }
      }
    }
    if (changes.level || changes.counter) {
      this.generateRandomExercise();
    }
  }

  initValues() {
    this.cards = [];
    this.cardIsVisible = [];
    this.isDisabled = false;
    this.numberOfTotalCards = 0;
  }

  generateRandomExercise() {
    this.initValues();

    this.numberOfTotalCards = this.getNumberOfCards();

    this.constructCardList();
  }

  getNumberOfCards() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 3); // 3 4
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 2) + 5); // 5 6
    } else {
      return Math.floor((Math.random() * 2) + 7); // 7 8
    }
  }

  constructCardList() {
    let i = 0;
    let isSorted = true;
    let lastValue = -1;
    while (i < this.numberOfTotalCards) {
      const randomId = Math.floor((Math.random() * 17));
      // Only use a card once in the list.
      if (this.cards.indexOf(randomId) === -1) {
        this.cards.push( randomId );
        i ++;

        if (lastValue > randomId) {
          isSorted = false;
        }
        lastValue = randomId;
      }
    }

    // Make sure no two consecutive exercise were already sorted.
    if (!isSorted) {
      this.wasSorted = false;
    } else if (this.wasSorted && isSorted) {
      const randomIndex = Math.floor(Math.random() * (this.cards.length - 2));
      const temp = this.cards[this.cards.length - 1];
      this.cards[this.cards.length - 1] = this.cards[randomIndex];
      this.cards[randomIndex] = temp;
      this.wasSorted = false;
    } else {
      this.wasSorted = true;
    }

    if (this.isCovered) {
      for (i = 0; i < this.numberOfTotalCards; i++) {
        this.cardIsVisible.push( false );
        this.changeButtonIsVisible.push( false );
      }
    } else {
      for (i = 0; i < this.numberOfTotalCards; i++) {
        this.cardIsVisible.push( true );
        this.changeButtonIsVisible.push( true );
      }
    }
    this.cardsChange.emit(this.cards);
  }

  checkIsLastCard(i: number): boolean {
    return (i === this.cards.length - 1);
  }

  /**
   * Swap card i with card i+1
   * Emit the new card list to the bubble-sort exercise, to check if the list is sorted.
   * @param i
   */
  changePos(i: number) {
    const temp = this.cards[i + 1];
    this.cards[i + 1] = this.cards[i];
    this.cards[i] = temp;
    if (this.isCovered) {
      this.changeButtonIsVisible[i] = false;
      setTimeout(() => { this.closeCards(i); }, 900);
    }
    this.cardsChange.emit(this.cards);
  }

  /**
   * If we have the cards covered, open card i and i+1.
   * Then the user can compare those cards and decide if he has to swap them.
   * @param i
   */
  showCards(i: number) {
    this.isDisabled = true;
    this.cardIsVisible[i] = true;
    this.cardIsVisible[i + 1] = true;
    this.changeButtonIsVisible[i] = true;
  }

  /**
   * If the user do not swap the opened cards, then he has to close the cards again
   * @param i
   */
  closeCards(i: number) {
    this.changeButtonIsVisible[i] = false;
    this.cardIsVisible[i] = false;
    this.cardIsVisible[i + 1] = false;
    this.isDisabled = false;
  }

  getImageSrc(cardId: number) {
    if (this.cardIsVisible[this.cards.indexOf(cardId)] === true || !(this.isCovered)) {
      return Cards[cardId].imageSrc;
    } else {
      return './assets/images/cards/cover.png';
    }
  }

  // Reduce the max width, when there are only some cards. otherwise too big.
  getMaxSize() {
    if (this.cards.length < 3) {
      return '45%';
    } else if (this.cards.length < 4) {
      return '70%';
    } else if (this.cards.length < 5) {
      return '80%';
    } else {
      return '100%';
    }
  }
}
